<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './assets/css/base.css'

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>



// WEBPACK FOOTER //
// src/App.vue